import React, { useEffect, useState } from 'react';
import { useWizard } from '../../wizard';
import { StepContainer, NavigationButtons, InfoBox } from '../index';
import { contentApi } from '../../services/contentApi';
import { contentKeys } from '../../constants/contentKeys';

const DeclarationLostPassportStep: React.FC = () => {
  const { goNext, goBack } = useWizard();
  const [title, setTitle] = useState('Erklæring om bortkommet pas');
  const [body, setBody] = useState<string[]>([
    'Du skal udfylde en erklæring om, at dit pas er bortkommet. Dette vil ske, når du møder op i Borgerservice.',
  ]);

  useEffect(() => {
    contentApi.getByKey(contentKeys.pas.declaration_lost).then(c => {
      if (c?.title) {setTitle(c.title);}
      if (c?.body && c.body.length > 0) {setBody(c.body);}
    });
  }, []);

  return (
    <StepContainer title={title}>
      <InfoBox type="warning">
        {body.map((p, i) => <p key={i}>{p}</p>)}
      </InfoBox>
      <NavigationButtons onBack={goBack} onNext={goNext} />
    </StepContainer>
  );
};

export default DeclarationLostPassportStep;
